import React from "react";
import { CalendarIcon } from "@heroicons/react/outline";

export default function X(props: any) {
    return (
        <CalendarIcon {...props} />
    );
}